const SUPPRESS_CONSOLE_LOGS = "false";
const appConfig = {
  suppressLogs: SUPPRESS_CONSOLE_LOGS === "true"
};
export default appConfig;
